import {gsap} from "../../../../libs/gsap/all.js"
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {AppearingContainer} from "./AppearingContainer";

// Constructor
export class Bubble extends AppearingContainer {

  constructor(x, y, size, color, appearingScreenPercent, game) {
    super(appearingScreenPercent, game);

    // top left position
    this.pos = {
      x: x,
      y: y
    }

    this.radius = size / 2;
    this.color = color;

    this.build();
  }

  build() {
    // Background
    let bubbleGraphics = new PIXI.Graphics()
      .circle(0, 0, this.radius) // draw from 0 so it's centered
      .fill(this.color);

    this.addChild(bubbleGraphics);

    // offset by the radius so we have the true top/left position
    this.position.x = this.pos.x + this.radius;
    this.position.y = this.pos.y + this.radius;

    this.reset();
  }

  buildAnimations() {
    this.inAnimation = gsap.fromTo(this,
      {
        pixi: {
          scale: 0
        }
      },
      {
        pixi: {
          scale: 1
        },
        ease: "back.out(1.7)",
        immediateRender: true, // makes the circle scale 0 immediately, even if tween is paused
        paused: true,
        duration: 0.5,
        onComplete: this.animate.bind(this), // start the animation loop once animated in
      }
    )

    this.mainAnimation = gsap.timeline({
      paused: true,
      repeat: -1,
      yoyo: true,
      delay: window.getRandomFloat(0, 0.1) // add a random delay before it starts so not all the bubbles are in sync
    });

    this.mainAnimation.fromTo(this,
      {
        pixi: {
          y: this.pos.y + this.radius
        },
      },{
        pixi: {
          y: this.pos.y + this.radius + 40
        },
        ease: "sine.inOut",
        duration: 2
      }
    );
  }

}
